import { Link, useNavigate, useLocation } from 'react-router-dom';
import './header-other.css';
import Cookies from 'js-cookie';
import DeliveryTime from './subcomponents/deliveryTime';

export default function HeaderOther() {

    const address = Cookies.get('address') === 'undefined' || Cookies.get('address') === undefined ? 'Select Address' : Cookies.get('address');
    
    const navigate = useNavigate();
    const location = useLocation();
    function back() {
        
        // Check if there is a navigation history within the app
        if (location.key !== 'default') {
            navigate(-1); // Go back to the previous page
        } else {
            navigate('/'); // Redirect to the home page
        }
    }

    return (

        <>
            <div className='header-other-container'>
                <div style={{display:'flex', flexDirection:'row'}}>
                    <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                        <button className='arrow-back' onClick={back}>
                            <img src='/icons/left-arrow.png' alt='back-arrow' style={{height:'14px', width:'14px'}} />
                        </button>
                    </div>
                    <div className='location-container' style={{marginTop: '10px'}}>
                        <DeliveryTime />
                        <div className='address-container'>
                            <Link to='/address-list' className='address'>{address?.length > 25 ? address.slice(0, 25) + "..." : address} &#9662;</Link>   
                        </div>
                    </div>
                </div>
                <div className='right-header-other'>
                    <div className='mobile-login-header-other' style={{marginRight: '10px'}}>
                        <Link to='/search' className='login-mobile-header-other'>
                            <div className='find-box'>
                                <img className='find-logo' src='/find.png' />
                            </div>
                        </Link>
                    </div>
                    <div className='order-btn-header-other'>
                        <Link to='/hamburger-menu'>
                            <div className='open-icon' style={{margin:'5px'}}></div>
                            <div className='open-icon' style={{margin:'5px'}}></div>
                            <div className='open-icon' style={{margin:'5px'}}></div>
                        </Link>
                    </div>
                </div>
            </div>     
        </>
    );
}